import angular from 'angular';

import TermsDialogComponent from './terms-dialog-component';
import { TermsDialogController } from './terms-dialog-controller';

export default angular
  .module('terms-dialog', [])
  .controller('TermsDialogController', TermsDialogController)
  .component('termsDialog', TermsDialogComponent);



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-dialog/terms-dialog-module.js